import angular from 'angular';
import '../resources/organization-information-screen';
import '../factories/socket.io';
import '../services/socket';

const module = angular.module('whyline.sockets.organization-information-screen', [
  'whyline.factories.socket',
  'whyline.services.socket',
  'whyline.resources.organization-information-screen',
]);

const OrganizationInformationScreenSocket = (OrganizationInformationScreen, $rootScope, SocketService) => {
  $rootScope.$on('socketReady', () => {
    SocketService.GetInstance().then(socket => {
      socket.on('socket:income-socket-message', (data) => {
        switch (data.type) {
          case 'organization-information-screen:created':
            handleOrganizationInformationScreenCreated(data);
            break;
          case 'organization-information-screen:updated':
            handleOrganizationInformationScreenUpdated(data);
            break;
          case 'organization-information-screen:enabled':
            handleOrganizationInformationScreenDeleted(data);
            break;
        }
      })

      const handleOrganizationInformationScreenCreated = (organizationInformationScreen) => {
        OrganizationInformationScreen.UpdateCache(organizationInformationScreen._id,
          organizationInformationScreen);
      }

      const handleOrganizationInformationScreenUpdated = (organizationInformationScreen) => {
        OrganizationInformationScreen.UpdateCache(organizationInformationScreen._id,
          organizationInformationScreen);
      }

      const handleOrganizationInformationScreenDeleted = (organizationInformationScreen) => {
        OrganizationInformationScreen.RemoveFromCache(organizationInformationScreen._id,
          organizationInformationScreen._type);
      }


    });
  });
};

module.exports = module.factory('OrganizationInformationScreenSocket', (OrganizationInformationScreen,
  $rootScope, SocketService) => new OrganizationInformationScreenSocket(OrganizationInformationScreen,
    $rootScope, SocketService));
